<template>
  <form class="px-5 padding-px">
    <div class="form-group row d-flex align-items-center pb-4">
      <div class="col-sm-2 d-flex justify-content-end justify-center mb-3">
        <div
          class="participants-picture-account rounded-circle"
          :style="'background: url('+user.profile_picture+')'"
        ></div>
      </div>
      <div class="col-sm-10">
        <div>
          <label class="btn btn-block-mobile btn-primary-outline">
            <input type="file" style="display:none;" v-on:change="onImageChange" />
            <span>{{ trans("account.upload_image") }}</span>
          </label>
        </div>
        <p class="text-gray mt-2 mb-0">{{ trans("account.upload_image_sub") }}</p>
      </div>
    </div>
    <div class="form-group d-flex align-items-center row">
      <label for class="col-sm-2 col-form-label justify-start">
        {{ trans("account.fullname") }}
      </label>
      <div class="col-sm-10">
        <input v-model="user.name" type="text" class="form-control bg-gray border-0" :class="{ 'is-invalid': $v.user.name.$error }"/>
      </div>
    </div>
    <div class="form-group d-flex align-items-center row">
      <label for class="col-sm-2 col-form-label justify-start">
        {{ trans("account.email") }}
      </label>
      <div class="col-sm-8">
        <h6 class="mb-0 font-weight-normal">{{ user.email }}</h6>
      </div>
    </div>
    <span v-if="user.role == 'participant'">
      <div class="form-group d-flex align-items-center row">
        <label class="col-sm-2 col-form-label justify-start">
          {{ trans("account.mykad") }}
        </label>
        <div class="col-sm-10">
          <input v-model="user.mykad" type="text" class="form-control bg-gray border-0" :class="{ 'is-invalid': $v.user.mykad.$error }"/>
        </div>
      </div>
      <div class="form-group d-flex align-items-center row">
        <label class="col-sm-2 col-form-label justify-start">
          {{ trans("account.phone") }}
        </label>
        <div class="col-sm-10">
          <input v-model="user.phone" type="text" class="form-control bg-gray border-0" :class="{ 'is-invalid': $v.user.phone.$error }"/>
        </div>
      </div>
      <div class="form-group d-flex align-items-center row">
        <label class="col-sm-2 col-form-label justify-start">
          {{ trans("account.dob") }}
        </label>
        <div class="col-sm-4">
          <input
            v-model="user.dob"
            type="date"
            class="form-control form-control-lg bg-gray border-0"
            :class="{ 'is-invalid': $v.user.dob.$error }"
          />
        </div>
      </div>
      <div class="form-group d-flex align-items-center row">
        <label class="col-sm-2 col-form-label justify-start">
          {{ trans("account.ethnicity") }}
        </label>
        <div class="col-sm-4">
          <select v-model="user.ethnic" class="form-control form-control-lg border-0 bg-gray" :class="{ 'is-invalid': $v.user.ethnic.$error }">
            <option :value="null">
              {{ trans("layout.please_select") }}
            </option>
            <option value="1">{{ trans("account.ethnicity_malay") }}</option>
            <option value="2">{{ trans("account.ethnicity_chinese") }}</option>
            <option value="3">{{ trans("account.ethnicity_indian") }}</option>
            <option value="4">{{ trans("account.ethnicity_others") }}</option>
          </select>
        </div>
      </div>
      <div class="form-group d-flex align-items-center row">
        <label class="col-sm-2 col-form-label justify-start">
          {{ trans("account.gender") }}
        </label>
        <div class="col-sm-4">
          <div class="btn-group btn-group-toggle btn-block" data-toggle="buttons">
            <label
              class="btn btn-gray"
              for="gender_male"
              v-bind:class="[user.gender == 1 ? 'active' : '']"
              @click="user.gender = 1"
            >
              <input
                id="gender_male"
                v-model="user.gender"
                type="radio"
                name="Male"
                autocomplete="off"
                value="1"
              />
              {{ trans("account.male") }}
            </label>
            <label
              for="gender_female"
              class="btn btn-gray"
              v-bind:class="[user.gender == 2 ? 'active' : '']"
              @click="user.gender = 2"
            >
              <input
                id="gender_female"
                v-model="user.gender"
                type="radio"
                name="Female"
                autocomplete="off"
                value="2"
              />
              {{ trans("account.female") }}
            </label>
          </div>
        </div>
      </div>
      <div class="form-group d-flex align-items-center row">
        <label class="col-sm-2 col-form-label justify-start">
          {{ trans("account.marital") }}
        </label>
        <div class="col-sm-4">
          <select
            v-model="user.marital_status"
            class="form-control form-control-lg border-0 bg-gray"
            :class="{ 'is-invalid': $v.user.marital_status.$error }"
          >
            <option :value="null">
              {{ trans("layout.please_select") }}
            </option>
            <option value="1">
              {{ trans("account.marital_single") }}
            </option>
            <option value="2">
              {{ trans("account.marital_married") }}
            </option>
            <option value="3">
              {{ trans("account.marital_divorced") }}
            </option>
            <option value="4">
              {{ trans("account.marital_widowed") }}
            </option>
          </select>
        </div>
      </div>
      <div class="form-group d-flex align-items-center row">
        <label class="col-sm-2 col-form-label justify-start">
          {{ trans("account.industry") }}
        </label>
        <div class="col-sm-4">
          <select v-model="user.industry_id" class="form-control form-control-lg border-0 bg-gray" :class="{ 'is-invalid': $v.user.industry_id.$error }">
            <option :value="null">
              {{ trans("layout.please_select") }}
            </option>
            <option
              v-for="industry in industries"
              :key="industry.id"
              :value="industry.id"
            >{{ industry.name }}</option>
          </select>
        </div>
      </div>
    </span>
    <div class="form-group row">
      <div class="col-sm-12 d-flex justify-content-end">
        <button
          @click="formSubmit"
          type="button"
          class="btn btn-primary btn-block-mobile px-5"
        >{{ trans("layout.save") }}</button>
      </div>
    </div>
  </form>
</template>
<script>
import { required } from "vuelidate/lib/validators";
export default {
  data() {
    return this.initData();
  },
  mounted() {
    this.loadUser();
  },
  validations: {
    user: {
        name: { required },
        email: { required },
        dob: { required },
        mykad: { required },
        ethnic: { required },
        industry_id: { required },
        phone: { required },
        gender: { required },
        marital_status: { required },
    }
  },
  methods: {
    initData() {
      return {
        user: {
          name: "",
          email: "",
          dob: "",
          mykad: "",
          ethnic: "",
          industry_id: "",
          phone: "",
          gender: "",
          marital_status: "",
          profile_picture: "",
        },
        image: "",
        industries: [],
      };
    },
    async loadUser(id) {
      let loader = this.$loading.show();
      try {
        var routeQuestion = "";
        if (window.current_lang == "en") {
          routeQuestion = route("api.en.industries.index");
        } else {
          routeQuestion = route("api.ms.industries.index");
        }

        const [user, industries] = await Promise.all([
          axios.get(route("api.account")),
          axios.get(routeQuestion),
        ]);
        this.industries = industries.data.data;
        this.user = user.data.data;
        loader.hide();
      } catch (e) {
        loader.hide();
        this.errorPopup(e);
      }
    },
    onImageChange(e) {
      console.log(e.target.files[0]);
      this.image = e.target.files[0];
    },
    async formSubmit() {
        this.$v.$touch()
        if (this.$v.$invalid) {
            console.log('error');
        } else {
            let loader = this.$loading.show();
            let formData = new FormData();
            formData.append("image", this.image);
            formData.append("user", JSON.stringify(this.user));
            try {
                const { data } = await axios.post(
                route("api.updateProfile"),
                formData,
                {
                    headers: {
                    "Content-Type": "multipart/form-data",
                    },
                }
                );
                location.reload();
            } catch (e) {
                loader.hide();
                if (e.response.status == 422){
                    if(e.response.data){
                        if(e.response.data['dob']){
                            this.user.dob = null;
                            this.$v.user.dob.$touch();
                            this.errorPopup(e.response.data['dob']);
                        }
                        if(e.response.data['mykad']){
                            this.errorPopup(e.response.data['mykad']);
                        }
                    }
                }else{
                    this.errorPopup(e.response.data.message);
                }
            }
        }
    },
  },
};
</script>
